@keyframes marquee {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}

.root {
  display: grid;
  gap: clamp(var(--space-12), 1.5vw, var(--space-20));
}

.viewport {
  min-width: 0;
  overflow: hidden;
  mask-image: linear-gradient(to right, transparent, #000 5%, #000 95%, transparent);

  /* без движения лента листается вручную */
  @media (prefers-reduced-motion: reduce) {
    overflow-x: auto;
    mask-image: none;
  }
}

.track {
  display: flex;
  width: max-content;
  &:where([data-looped="true"]) {
    animation: marquee var(--marquee-duration) linear infinite;
  }
  &:where([data-reverse="true"]) {
    animation-direction: reverse;
  }
  &:where([data-running="false"]) {
    animation-play-state: paused;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      animation-play-state: paused;
    }
  }

  /* фокус на строке — тоже пауза: пользователь клавиатуры читает знаки */
  *:focus-visible > & {
    animation-play-state: paused;
  }

  /* глобальный сброс длительностей здесь не подходит: лента прыгнула бы в конечное положение */
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
}

.list {
  display: flex;
  gap: clamp(var(--space-10), 1.2vw, var(--space-16));
  /* Отступ после списка равен зазору — у обеих копий одинаковая ширина, шов не виден */
  padding: 0 clamp(var(--space-10), 1.2vw, var(--space-16)) 0 0;
  margin: 0;
  list-style: none;
}

.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-8);
  width: clamp(136px, 11.5vw, 168px);
}

.plate {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: clamp(96px, 8.5vw, 120px);
  padding: var(--space-12) var(--space-14);
  background: var(--color-media-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-small);
}

.plate .logo {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.caption {
  font-size: var(--type-caption);
  line-height: 1.3;
  text-align: center;
  color: var(--color-text-muted);
  /* Полное название важнее одинаковой высоты подписи: при увеличении шрифта отдельным
     заказчикам нужно пять строк. Вся строка ленты принимает высоту самой длинной подписи. */
  display: block;
  overflow-wrap: anywhere;
}

.plate[data-coat="true"] {
  padding: var(--space-10);
}
@media (prefers-reduced-motion: reduce) {
  .list[aria-hidden="true"] {
    display: none;
  }
}
